import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html'
})

export class NewsComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  navigateWaitingRoom() {
    this.router.navigate(['/consultation/waiting-room']);
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/news/news.component.ts